'use client'

import { deleteCookie } from 'cookies-next/client'
import { type FC, useEffect } from 'react'
import { useIntl } from 'react-intl'

import { ExperimentsPageTypeProvider } from '../../experiments/components/ExperimentsPageTypeContext'
import { EXPERIMENT_PAGE_TYPE_CONTACT } from '../../experiments/ExperimentPageType'
import { useGlobalConfigContext } from '../../global-config'
import { INVOICES_SECTION_KEY } from '../../order-question'
import { StandardShopLayout } from '../../standard-shop-layout'

import { contactPageGetFaqCards } from './ContactPageFaqCards'
import { ContactPageFaqCardsSection } from './ContactPageFaqCardsSection'
import { ContactPageLayout } from './ContactPageLayout'
import { ContactPageMetas } from './ContactPageMetas'
import { type ContactPageProps } from './ContactPageProps'
import { ContactPageOrdersSection } from './ContactPageSections/ContactPageOrdersSection'

export const ContactPage: FC<ContactPageProps> = ({ standardLayoutData }) => {
  const intl = useIntl()
  const config = useGlobalConfigContext()

  useEffect(() => {
    deleteCookie(INVOICES_SECTION_KEY)
  }, [])

  return (
    <ExperimentsPageTypeProvider pageType={EXPERIMENT_PAGE_TYPE_CONTACT}>
      <StandardShopLayout standardLayoutData={standardLayoutData}>
        <main>
          <ContactPageMetas />
          <ContactPageLayout>
            <ContactPageOrdersSection />
            <ContactPageFaqCardsSection
              cards={contactPageGetFaqCards(config, intl)}
            />
          </ContactPageLayout>
        </main>
      </StandardShopLayout>
    </ExperimentsPageTypeProvider>
  )
}
